
import React from "react";

// Définition des types pour les correspondances de région
interface RegionMapProps {
  regionMap: Record<string, string>;
}

const RegionMap: React.FC<RegionMapProps> = ({ regionMap }) => {
  return (
    <div className="hidden">
      {/* 
        Ce composant existe uniquement pour exporter la correspondance départements-régions.
        Il n'a pas de rendu visuel, mais permet de maintenir cette logique séparément.
      */}
    </div>
  );
};

// Exporter la carte des régions pour la réutilisation
export const defaultRegionMap: Record<string, string> = {
  '12': 'Occitanie',
  '81': 'Occitanie',
  '15': 'Auvergne-Rhône-Alpes',
  '95': 'Île-de-France',
  '46': 'Occitanie',
  '11': 'Occitanie',
  '31': 'Occitanie',
  '34': 'Occitanie',
  '48': 'Occitanie',
  '30': 'Occitanie',
  '82': 'Occitanie',
  '93': 'Île-de-France',
  '92': 'Île-de-France',
  '75': 'Île-de-France',
  '78': 'Île-de-France',
  '43': 'Auvergne-Rhône-Alpes',
  '63': 'Auvergne-Rhône-Alpes'
};

export default RegionMap;
